import React, { useCallback, useMemo } from 'react';

import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { toast } from 'react-toastify';

import AutoSeedDialog, { type AutoSeedProps } from 'components/dialogs/autoSeedDialog/AutoSeedDialog';
import { TOURNAMENT_ENGINE } from 'config/graphql/constants';
import { useSaveTournament } from 'hooks/tournament/useSaveTournament';

const Modal = NiceModal.create(({ event, ratingType, payload, clearSeeds }: AutoSeedProps) => {
  const modal = useModal();
  const { saveTournament, saving: autoSeedProgress } = useSaveTournament();

  const handleAutoSeeding = useCallback(async () => {
    await clearSeeds(true);
    const method = {
      method: 'setParticipantScaleItems',
      params: payload,
    };
    const res = await saveTournament('autoSeeding', TOURNAMENT_ENGINE, [method]);
    if (res?.data?.mutateTournament?.success) {
      toast.success('Auto seeding successful');
    }
  }, [clearSeeds, payload, saveTournament]);

  return (
    <AutoSeedDialog
      event={event}
      loading={autoSeedProgress}
      open={modal.visible || autoSeedProgress}
      ratingType={ratingType}
      onClose={modal.hide}
      onExited={modal.remove}
      onSave={handleAutoSeeding}
    />
  );
});

export const useAutoSeedDialog = () => {
  const handleShow = useCallback(({ event, ratingType, payload, clearSeeds }) => {
    return NiceModal.show(Modal, { event, ratingType, payload, clearSeeds } as AutoSeedProps);
  }, []);
  return useMemo(() => handleShow, [handleShow]);
};
